import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { reducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { ReportsEffects } from './effects/reports.effects';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SnackBarToastModule } from '../../shared/components/snack-bar-toast/snack-bar-toast.module';

@NgModule({
  imports: [
    StoreModule.forFeature('reportState', reducers),
    EffectsModule.forFeature([
      ReportsEffects
    ]),
    MatSnackBarModule,
    SnackBarToastModule
  ]
})
export class ReportsStoreModule {}
